import React, { useState } from 'react';
import { makeStyles, Dialog, Slide, Box, Typography, Button } from '@material-ui/core';
import SearchTime from 'views/motorcycle_rental/components/widget/SearchTime';
import OverlayStyle from 'views/motorcycle_rental/components/widget/OverlayStyle';
import CloseIcon from '@material-ui/icons/Close';
import { withTranslation } from 'config/i18n';

const useStyles = makeStyles((theme) => ({
  ...OverlayStyle(theme),
  rangePickerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 33,
  },
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const SearchTimeModal = ({ t, data, disabled }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box display="flex" height="100%" width="100%" position="relative">
        <Box
          className={classes.rangePickerOverlay}
          onClick={() => (disabled ? null : setOpen(true))}
        />
        <SearchTime data={{ ...data, disabled: true, showClearDates: false }} />
      </Box>
      <Dialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        TransitionComponent={Transition}
        className={classes.placeModalRoot}
      >
        <Box p={2}>
          <Box className={classes.overlayHeader}>
            <Typography className={classes.overlayTitle}>
              {t('fe_es_geo_widget:time.label')}
            </Typography>
            <CloseIcon onClick={() => setOpen(false)} className={classes.closeIcon} />
          </Box>
          <Box>
            <SearchTime data={{ ...data, withoutInput: true }} />
          </Box>
        </Box>
        <Box display="flex" p={2} justifyContent="stretch">
          <Box mr={1} width="50%">
            <Button
              onClick={data.handleClearRangePicker}
              variant="outlined"
              color="secondary"
              fullWidth
            >
              {t('fe_es_geo_widget:time.clear')}
            </Button>
          </Box>
          <Box ml={1} width="50%">
            <Button onClick={() => setOpen(false)} variant="contained" color="primary" fullWidth>
              {t('fe_es_geo_widget:overlay.save_search')}
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default withTranslation(['fe_es_geo_widget'])(SearchTimeModal);
